exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#aa-video-ad-unit .upper-controls.enabled {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding: 8px 12px;\n    background: rgba(0,0,0,0.5);\n    color: white;\n    margin: auto;\n    width: 25%;\n    text-align: center;\n    transition: top ease 0.125s;\n    z-index: 2;\n    display: block;\n}\n\n#aa-video-ad-unit .upper-controls {\n    display: none;\n}\n\n#aa-video-ad-unit .upper-controls .skip {\n    float: right;\n}\n\n#aa-video-ad-unit .upper-controls .skip.no-countdown {\n    float: none;\n}\n\n#aa-video-ad-unit.hover-false .upper-controls {\n    top: -30px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Display/Components/UpperControls/UpperControls.css
// module id = 166
// module chunks = 6